module.exports = __webpack_public_path__ + "img/nettoyant-insecte.a2014db4.jpg";